module.exports = __webpack_public_path__ + "media/images/demo_tests/balloons-515b94b41b5ca8cfad347602c825b5f4.gif";